"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_consensus_1 = require("@branch-ts/app-consensus");
const web_consensus_1 = require("@branch-ts/web-consensus");
const app_VersetWebapp_1 = require("./app.VersetWebapp");
app_consensus_1.VAS.declareCurrentApp({
    app: async () => {
        const app = (0, app_VersetWebapp_1.App)({});
        await new web_consensus_1.AppContainer({ app }).serve();
        return app;
    },
});
